import {
  DEFAULT_PLATFORM,
  DOMAIN_TO_PLATFORM_MAPPING,
  SupportedPlatform,
} from "../constants/platforms";

/**
 * "Platform" has a lot of meanings right now. Until we have a clear definition
 * of what it is, and in the context of this function, it's a direct mapping
 * between the URI of a Container and a product: Insights, Visor, etc.
 *
 * For example, any URI that has `visor.ag` as a domain name maps to the
 * `visor` product. We're calling this product a 'platform'. Each 'platform'
 * (a) Has a separate copy of the container and (b) its own URI.
 *
 * It is expected that new platforms will be deployed to their own separate
 * URIs. E.g. A new Seed SkyNet™ platform that only serves customers in Canada
 * and Argentina would be hosted in prod at
 *
 *      https://ca.seeds.skynet.ag
 *      https://ar.seeds.skynet.ag
 *
 * Assuming this is the case, we can simply use the domain name to determine
 * the platform. The default platform is `insights` (e.g. if you're developing
 * locally.)
 */
export const getPlatform = (): SupportedPlatform => {
  /**
   * Quick reminder:
   *
   * - Hostname: `foo`
   * - Domainname: `bar.com` (where TLD is `.com`)
   * - FQDN: `foo.bar.com`
   */
  for (const domain in DOMAIN_TO_PLATFORM_MAPPING) {
    if (window.location.hostname.endsWith(domain)) {
      return DOMAIN_TO_PLATFORM_MAPPING[domain];
    }
  }

  return DEFAULT_PLATFORM;
};
